export interface IAddress {
  street: string;
  number: string;
  neighborhood: string;
  city: string;
  state: string;
}

export interface IEvent {
  address: IAddress;
  date: string;
}

export interface IProduct {
  id: string;
  title: string;
  type: string;
  image: string;
  delivery_nutror: string;
  download_hash: string;
  event?: IEvent;
  allows_card: boolean;
  valid_to_refund_request: boolean;
}

export interface IProducer {
  email: string;
  name: string;
  phone: string;
  address: string;
  skype: string;
  facebook: string;
  id: number;
}

export interface IOrder {
  status: string;
  tracker_code: string;
  delivery_date: string;
  expected_date: string;
}

export enum EPaymentStatus {
  EM_DIA = 1,
  AGUARDANDO_PAGAMENTO = 2,
  SUSPENSO = 3,
  CANCELADO = 4,
  ATRASADO = 7,
  FINALIZADO = 9,
  TRIAL = 10,
  INADIMPLENTE = 11,
}

export interface IPaymentStatus {
  id: EPaymentStatus;
  name: string;
  alias: string;
}

export enum ERequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REPROVED = 'reproved',
}

export enum ERequestType {
  REQUEST = 'REQUEST',
}

export type TRefundRequestStatus = 'approved';

export interface ICanRefund {
  can_refund: boolean;
  can_refund_reason: string;
}

export interface IRefundRequest {
  exist: boolean;
  invoice_id: string;
  status: ERequestStatus;
  justification: string;
  requested_at: Date;
}

export interface IHasUserBetaModule {
  data: boolean;
}

export interface IShoppingProduct {
  subscription_id?: number;
  product: IProduct;
  producer: IProducer;
  customer: ICustomer;
  payment_status: IPaymentStatus;
  payment_method: IPaymentMethod;
  order: IOrder;
  invoice_id: string;
  created_at: string;
  received_at: string;
  total_value: number;
  freight_value: number;
  card_number: string;
  unlimited_installment: boolean;
  currency_code: string;
}

export interface IFrequency {
  frequency: string;
  frequency_type: string;
  frequency_reference: number;
  total_cycles: string;
  number_of_charges: string;
}

export interface IPaymentMethod {
  id: EPaymentMethod;
  name: string;
}

export enum EPaymentMethod {
  BOLETO = 1,
  PIX = 32,
}

export interface ICustomer {
  id: number;
  name: string;
  business_name: string;
  email: string;
  celphone: string;
}

export interface IAffiliate {
  id: number;
  email?: any;
}

export interface IShoppingSubscription extends IShoppingProduct {
  id: number;
  first_invoice_id: string;
  frequency_details: IFrequency;
  payment_charges: string;
  cycles: string;
  total_price: number;
  unit_price: number;
  amount: number;
  updated_at: string;
  initial_date: string;
  canceled_at: string;
  next_charge_date: string;
  payment_method: IPaymentMethod;
  affiliate: IAffiliate;
  allows_change_plan?: boolean;
  changed_plan_at?: string;
  currency: string;
}

export interface ITicket {
  amount?: number;
  coupon_id?: number;
  coupon_key?: string;
  created_at?: string;
  description?: string;
  discount?: number;
  id?: number;
  quantity?: number;
  transaction_item_id?: number;
  unit_value?: number;
}

export interface IFiscalDocuments {
  ext?: string;
  id?: number;
  name?: string;
  status?: string;
  title?: string;
  url?: string;
}

export type SubscriptionProductChangePlan = {
  id: number;
  title: string;
  undetermined_charges: string;
  frequency: string;
  frequency_type: string;
  value: number;
  payment_method_id: number;
  payment_method_name: string;
  card_number: string;
  lastInvoice: {
    due_date: string;
    creation_date: string;
    value: number;
  };
  nextInvoice: {
    due_date: string;
    creation_date: string;
    value: number;
    max_installments: number;
  };
  planType: 'upgrade' | 'downgrade';
  allows_installments: boolean;
};
